import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, IHeaderParams } from 'ag-grid-community';

@Component({
  template: `
    <div
      style="margin-left: 1px;"
      [ngClass]="{ 'ag-checked': selectAll }"
      class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
      role="presentation"
    >
      <input class="ag-input-field-input ag-checkbox-input" type="checkbox" [checked]="selectAll" (change)="onCheckboxClick()" />
    </div>
  `,
  standalone: false
})
export class GridHeaderSelectComponent implements IHeaderAngularComp {
  private params: any;
  public selectAll = false;
  public hideCheckbox = false;

  agInit(headerParams: IHeaderParams): void {
    // console.log(`Init HeaderComponent`);

    this.params = headerParams;

    if (!this.params.api.selectAllComponentCheckbox) {
      this.params.api.selectAllComponentCheckbox = false;
    }
    this.params.api.selectAllComponent = this;

    //
    // const rowCount = this.params.api.getDisplayedRowCount();
    // const lastGridIndex = rowCount - 1;
    // const currentPage = this.params.api.paginationGetCurrentPage();
    // const pageSize = this.params.api.paginationGetPageSize();
    // const startPageIndex = currentPage * pageSize;
    // let endPageIndex = (currentPage + 1) * pageSize - 1;
    //
    // if (endPageIndex > lastGridIndex) {
    //   endPageIndex = lastGridIndex;
    // }
    //
    // // Count selected rows
    // let cptSelected = 0;
    // for (let i = startPageIndex; i <= endPageIndex; i++) {
    //   const rowNode = this.params.api.getDisplayedRowAtIndex(i);
    //   cptSelected += rowNode.selected ? 1 : 0;
    // }
    //
    // // Check the checkbox if all the rows are selected
    // const cptRows = endPageIndex + 1 - startPageIndex;
    // this.selectAll = cptSelected && cptRows <= cptSelected;
  }

  refresh(params: IHeaderParams): boolean {
    return true;
  }
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    throw new Error('Method not implemented.');
  }

  // ngOnDestroy() {
  //   console.log(`Destroying HeaderComponent`);
  // }

  onCheckboxClick(): void {
    this.params.api.selectAllComponentClick();

    // const rowCount = this.params.api.getDisplayedRowCount();
    // const lastGridIndex = rowCount - 1;
    // const currentPage = this.params.api.paginationGetCurrentPage();
    // const pageSize = this.params.api.paginationGetPageSize();
    // const startPageIndex = currentPage * pageSize;
    // let endPageIndex = (currentPage + 1) * pageSize - 1;
    //
    // if (endPageIndex > lastGridIndex) {
    //   endPageIndex = lastGridIndex;
    // }
    //
    // this.selectAll = !this.selectAll;
    //
    // for (let i = startPageIndex; i <= endPageIndex; i++) {
    //   const rowNode = this.params.api.getDisplayedRowAtIndex(i);
    //   rowNode.setSelected(this.selectAll);
    // }
  }
}
